/* Aventurx — Promo abbinate (snippets/axr-bundle.liquid).
   - pulsanti dei riquadri: giacca + paraschiena, solo paraschiena, articolo + sottocasco scelto (COTTON/PILE),
     solo il sottocasco (nel carrello prende il posto dell'altro sottocasco);
   - dopo ogni modifica del carrello rilegge i riquadri della pagina prodotto (?section_id=axr-bundle-pdp);
   - nasconde i riquadri prima dell'inizio e dopo la fine della promo (ora del dispositivo, utile con pagine in cache).
   Il cassetto e la pagina del carrello si aggiornano da soli (data-merge="axr-bundle"). */
(function () {
  'use strict';
  if (window.axrBundle) return;
  window.axrBundle = true;

  var rawFetch = window.fetch ? window.fetch.bind(window) : null;
  var strings = window.axrBundleStrings || {};
  var variants = {}; // ultima variante scelta per prodotto: { id, available }
  var refreshTimer = null;
  var busy = false;

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function post(url, body) {
    return rawFetch(root() + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw d; }, function () { throw {}; });
      return r.json();
    });
  }

  function cartChanged() {
    document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } }));
  }

  function say(box, text, isError) {
    var msg = box && box.querySelector('.axr-bd__msg');
    if (!msg) return;
    msg.textContent = text || '';
    msg.hidden = !text;
    msg.classList.toggle('is-error', !!isError);
  }

  // variante del prodotto della pagina (giacca o articolo che conta per il sottocasco): quella scelta, o niente se la taglia non è scelta
  function jacketVariant(pid) {
    if (variants[pid]) return variants[pid];
    var form = document.querySelector('form.js-product-form[data-product-id="' + pid + '"]');
    var input = form && form.querySelector('[name="id"]');
    var id = input && input.value ? parseInt(input.value, 10) : 0;
    return id ? { id: id, available: null } : null;
  }

  function jacketQuantity(pid) {
    var form = document.querySelector('form.js-product-form[data-product-id="' + pid + '"]');
    var q = form && form.querySelector('[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function showSizes(pid) {
    var form = document.querySelector('form.js-product-form[data-product-id="' + pid + '"]');
    var detail = form && form.closest('.product-detail');
    var opt = detail && detail.querySelector('.option-selectors, .option-selector, variant-picker');
    if (!opt) return;
    var top = opt.getBoundingClientRect().top + window.pageYOffset - 110;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    opt.classList.add('axr-bd-flash');
    setTimeout(function () { opt.classList.remove('axr-bd-flash'); }, 1600);
  }

  function add(btn) {
    if (!rawFetch || btn.classList.contains('is-loading')) return;
    var kind = btn.getAttribute('data-axr-bd-add');
    var box = btn.closest('.axr-bd');
    var items = [];
    var remove = [];
    say(box, '');

    if (kind === 'bala' || kind === 'bala-both') {
      // sottocasco: quello del pulsante (carrello) o quello scelto tra COTTON e PILE (pagina prodotto)
      var vid = parseInt(btn.getAttribute('data-variant'), 10);
      if (!vid) {
        var choice = box && box.querySelector('.axr-bd-choices input:checked');
        vid = choice ? parseInt(choice.value, 10) : 0;
      }
      if (!vid) return;
      if (kind === 'bala-both') {
        var mid = box.getAttribute('data-main');
        var mv = jacketVariant(mid);
        var mavail = box.getAttribute('data-avail') || '';
        if (!mv) {
          say(box, strings.pickOption || strings.pickSize, true);
          showSizes(mid);
          return;
        }
        if (mv.available === false || (mv.available === null && mavail.indexOf(',' + mv.id + ',') === -1)) {
          say(box, strings.optionSoldOut || strings.jacketSoldOut, true);
          showSizes(mid);
          return;
        }
        items.push({ id: mv.id, quantity: jacketQuantity(mid) });
      }
      items.push({ id: vid, quantity: 1 });
      // un solo sottocasco in promo: quello scelto prende il posto dell'altro
      remove = (btn.getAttribute('data-remove') || '').split(',').filter(Boolean);
    } else {
      var picked = box && box.querySelector('.axr-bd-sizes input:checked');
      var pv = picked ? parseInt(picked.value, 10) : 0;
      if (!pv) return;
      if (kind === 'both') {
        var pid = box.getAttribute('data-jacket');
        var jv = jacketVariant(pid);
        var avail = box.getAttribute('data-avail') || '';
        if (!jv) {
          say(box, strings.pickSize, true);
          showSizes(pid);
          return;
        }
        if (jv.available === false || (jv.available === null && avail.indexOf(',' + jv.id + ',') === -1)) {
          say(box, strings.jacketSoldOut, true);
          showSizes(pid);
          return;
        }
        items.push({ id: jv.id, quantity: jacketQuantity(pid) });
      }
      items.push({ id: pv, quantity: 1 });
    }

    btn.classList.add('is-loading');
    busy = true;
    var chain = Promise.resolve();
    remove.forEach(function (key) {
      chain = chain.then(function () { return post('cart/change.js', { id: key, quantity: 0 }); });
    });
    chain.then(function () {
      return post('cart/add.js', { items: items });
    }).then(function () {
      busy = false;
      btn.classList.remove('is-loading');
      if (window.theme && theme.settings && theme.settings.cart_type === 'page') {
        window.location = root() + 'cart';
        return;
      }
      say(box, strings.added, false);
      cartChanged();
      scheduleRefresh(500);
    }).catch(function (err) {
      busy = false;
      btn.classList.remove('is-loading');
      say(box, (err && (err.description || err.message)) || strings.error, true);
      scheduleRefresh(300);
    });
  }

  // riquadri della pagina prodotto riletti dal negozio dopo una modifica del carrello
  function refresh() {
    if (!rawFetch) return;
    document.querySelectorAll('[data-axr-bd-pdp][data-url]').forEach(function (wrap) {
      var url = wrap.getAttribute('data-url');
      if (!url) return;
      rawFetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=axr-bundle-pdp', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-axr-bd-pdp]');
          // conserva le scelte del cliente (taglia del paraschiena, sottocasco)
          var keep = [];
          wrap.querySelectorAll('.axr-bd-sizes input:checked, .axr-bd-choices input:checked').forEach(function (el) {
            keep.push([el.closest('.axr-bd-sizes') ? '.axr-bd-sizes' : '.axr-bd-choices', el.value]);
          });
          wrap.innerHTML = fresh ? fresh.innerHTML : '';
          keep.forEach(function (k) {
            var again = wrap.querySelector(k[0] + ' input[value="' + k[1] + '"]:not([disabled])');
            if (again) again.checked = true;
          });
          windowCheck(wrap);
        })
        .catch(function () {});
    });
  }
  function scheduleRefresh(ms) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, ms || 700);
  }

  // periodo della promo nell'ora del dispositivo (date "2026-10-23 08:00" o "23/10/2026 08:00")
  function parse(str) {
    if (!str) return null;
    var s = String(str).trim();
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2})[:.](\d{2}))?$/.exec(s);
    if (m) return new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), 0);
    m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2})[:.](\d{2}))?$/.exec(s);
    if (m) return new Date(+m[3], +m[2] - 1, +m[1], +(m[4] || 0), +(m[5] || 0), 0);
    return null;
  }
  function windowCheck(scope) {
    if (window.Shopify && window.Shopify.designMode) return;
    var now = new Date();
    var els = [];
    if (scope && scope.hasAttribute && scope.hasAttribute('data-axr-bd-window')) els.push(scope);
    (scope || document).querySelectorAll('[data-axr-bd-window]').forEach(function (el) { els.push(el); });
    els.forEach(function (el) {
      var start = parse(el.getAttribute('data-start'));
      var end = parse(el.getAttribute('data-end'));
      var off = (start && now < start) || (end && now >= end);
      el.classList.toggle('is-bd-off', !!off);
    });
  }

  function init() {
    document.addEventListener('click', function (evt) {
      var btn = evt.target.closest && evt.target.closest('[data-axr-bd-add]');
      if (!btn) return;
      evt.preventDefault();
      add(btn);
    });
    // la variante scelta della giacca (taglia, colore)
    document.addEventListener('on:variant:change', function (evt) {
      var v = evt.detail && evt.detail.variant;
      var form = evt.target && evt.target.closest ? evt.target.closest('[data-ajax-add-to-cart], .product-detail') : null;
      var f = form && form.querySelector('form.js-product-form[data-product-id]');
      var pid = f && f.getAttribute('data-product-id');
      if (!pid) return;
      variants[pid] = v ? { id: v.id, available: !!v.available } : null;
      document.querySelectorAll('[data-axr-bd-prot][data-jacket="' + pid + '"], [data-axr-bd-bala][data-main="' + pid + '"]').forEach(function (box) { say(box, ''); });
    }, true);
    document.addEventListener('theme:cartchanged', function () { if (!busy) scheduleRefresh(800); });
    // carrello cambiato da altri script (cassetto, app): si osservano le chiamate al carrello
    if (rawFetch && !window.fetch.__axrBundle) {
      var current = window.fetch;
      var wrapped = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var res = current.apply(window, arguments);
        if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url) && !busy) res.then(function () { scheduleRefresh(900); }, function () {});
        return res;
      };
      wrapped.__axrBundle = true;
      wrapped.__axrGift = current.__axrGift;
      window.fetch = wrapped;
    }
    windowCheck(document);
    // il cassetto del carrello si ridisegna: si ricontrolla il periodo
    var drawerObserver = new MutationObserver(function (list) {
      list.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) windowCheck(n.parentNode || n); });
      });
    });
    document.querySelectorAll('.axr-bd-slot').forEach(function (slot) { drawerObserver.observe(slot, { childList: true }); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
